export function buildClientRouteMountElement(options: {
    componentName: string;
    className: string;
    dataset: Record<string, string>;
}): HTMLElement {
    const element = document.createElement("div");
    element.className = options.className;
    element.setAttribute("data-component", options.componentName);

    Object.entries(options.dataset).forEach(([key, value]) => {
        element.dataset[key] = value;
    });

    return element;
}

export function replaceNavigationRootContent(root: HTMLElement, nextContent: HTMLElement | HTMLElement[]): void {
    root.replaceChildren(...(Array.isArray(nextContent) ? nextContent : [nextContent]));
}
